import { LabeledValueType } from 'components/CIMSSelect/types'

export function decodeConnectionValues(values: LabeledValueType[]) {
  return values.reduce(
    (ids, { value }) => {
      const [type, id] = value.toString().split('_')
      if (type === 'internal') ids.internalConnectionIds.push(id)
      else if (type === 'workflow') ids.workflowIds.push(id)
      else ids.connectionIds.push(id)
      return ids
    },
    {
      connectionIds: Array<string>(),
      internalConnectionIds: Array<string>(),
      workflowIds: Array<string>(),
    }
  )
}
